<template>
    <div>
        <div class="text-xs-right">
            <v-layout justify-end align-center class="button-group">
                <!-- Bouton Transfer Money amélioré -->
                <v-menu offset-y transition="slide-y-transition" origin="top right">
                    <template v-slot:activator="{ on }">
                        <v-btn
                            class="white--text elevation-4 transfer-btn"
                            small
                            rounded
                            color="purple darken-2"
                            v-on="on"
                        >
                            <v-icon left small>fas fa-exchange-alt</v-icon>
                            <span>Transfer</span>
                            <v-icon right x-small>fas fa-chevron-down</v-icon>
                        </v-btn>
                    </template>

                    <v-card class="elevation-12 menu-card" width="200">
                        <v-list dense class="py-0 menu-list">
                            <v-list-item
                                @click="goToRoute('savings.money_transfer.send')"
                                ripple
                                class="menu-item send-item"
                            >
                                <v-list-item-icon class="mr-2">
                                    <v-icon small color="teal darken-3" class="fas fa-paper-plane"></v-icon>
                                </v-list-item-icon>
                                <v-list-item-title class="teal--text text--darken-3 font-weight-medium body-2">
                                    Send Money
                                </v-list-item-title>
                            </v-list-item>

                            <v-divider class="my-0 menu-divider"></v-divider>

                            <v-list-item
                                @click="goToRoute('savings.money_transfer.sent_history')"
                                ripple
                                class="menu-item receive-item"
                            >
                                <v-list-item-icon class="mr-2">
                                    <v-icon small color="purple darken-3" class="fas fa-clock-rotate-left"></v-icon>
                                </v-list-item-icon>
                                <v-list-item-title class="purple--text text--darken-3 font-weight-medium body-2">
                                    Sent History
                                </v-list-item-title>
                            </v-list-item>

                            <v-divider class="my-0 menu-divider"></v-divider>

                            <v-list-item
                                @click="goToRoute('savings.money_transfer.received_history')"
                                ripple
                                class="menu-item receive-item"
                            >
                                <v-list-item-icon class="mr-2">
                                    <v-icon small color="blue darken-3" class="fas fa-history"></v-icon>
                                </v-list-item-icon>
                                <v-list-item-title class="blue--text text--darken-3 font-weight-medium body-2">
                                    Receive History
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-menu>

                <!-- Bouton New Campaign existant (inchangé) -->
                <div v-if="$store.state.lengthActiveCampaigns < 2" class="mr-2">
                    <v-btn
                        class="white--text elevation-4"
                        small
                        rounded
                        color="teal darken-2"
                        :to="{name: 'campaigns.new_campaign'}"
                        style="min-width: 140px; border-radius: 24px;"
                    >
                        <v-icon left small class="fas fa-plus"></v-icon>
                        <span>New Campaign</span>
                    </v-btn>
                </div>
                <div v-else class="mr-2">
                    <v-btn
                        class="white--text elevation-4"
                        small
                        rounded
                        color="teal darken-2"
                        @click="completeActiveCampaignMsg()"
                        style="min-width: 140px; border-radius: 24px;"
                    >
                        <span>New Campaign</span>
                    </v-btn>
                </div>
            </v-layout>
        </div>


        <div v-if="campaigns.length === 0">
            <h1>No {{$route.params.category}} campaigns exists yet</h1>
        </div>
        <v-card class="elevation-4 mt-2" style="border-radius: 10px" v-for="item in campaigns" :key="item.key">
            <v-layout row wrap text-xs-center v-if="item.principal">
                <h2 class="pa-2 dark--text text-xs-left"><span class="blue--text">Current Account:</span> {{item.saved_amount}} FCFA</h2>
            </v-layout>
        </v-card>

        <div class="mt-3 pa-0" style="max-height: 400px; overflow: auto">
            <v-hover v-for="item in campaigns" :key="item.id">
                <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 18 : 4}`"  color="white" style=""
                    :key="item.key"
                    :to="'/savings/campaigns/detail/'+item.id"
                >
                    <v-card-text class="px-3 py-2 " v-if="!item.principal && !item.marketer" style="font-size: 12px; cursor: pointer">
                        <h2 :class="titleColor">Campaign: {{item.name}}<blink v-if="item.notification" class="pt-0 mt-0" style="font-size: 8px; position: relative; top: 0"><i class="red--text fas fa-circle"></i></blink></h2>
                        <span><b>Creation Date:</b> {{item.get_date_str}}</span>
                        <v-spacer></v-spacer>
                        <div v-if="item.target_amount && item.target_date" >
                            <span><b>Objective:</b> Reach {{item.target_amount}} FCFA By the {{item.target_date}} </span>
                        </div>
                        <div v-else-if="item.target_amount" >
                            <span><b>Objective:</b> Reach {{item.target_amount}} FCFA </span>
                        </div>
                        <div v-else-if="item.target_date" >
                            <span><b>Objective:</b> On the {{item.target_date}} </span>
                        </div>
                    </v-card-text>
                <v-divider></v-divider>
                </v-card>
            </v-hover>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        data() {
            return {
                page: 1,
                campaigns: [],
                titleColor: 'teal--text',
            }
        },

        methods:{
            completeActiveCampaignMsg(){
                this.$store.commit('setSnackBarMessage', "Your active campaigns have reached the maximum limit of 2, please complete them first.")
                this.$store.commit('setSnackBarColor', "red darken-4")
                this.$store.commit('activateSnackBar', true)
            },
            goToRoute(routeName) {
                this.$router.push({ name: routeName });
            },
            async getCampaigns(){
                this.$store.commit('setIsLoading', true)

                const campaign_category = this.$route.params.category
                await axios
                    .get('/api/v1/savings/get/user/campaigns/'+campaign_category+'/')
                    .then(response => {
                        this.campaigns = response.data
                        if (campaign_category === 'all'){
                            this.titleColor = 'grey--text'
                        }
                        else if (campaign_category === 'active'){
                            this.titleColor = 'teal--text'
                            this.$store.commit('setLengthActiveCampaigns', this.campaigns.length)
                        }
                        else if (campaign_category === 'interrupted'){
                            this.titleColor = 'red--text'
                        }
                        else if (campaign_category === 'completed'){
                            this.titleColor = 'blue--text'
                        }
                    })
                    .catch(error => {
                        if (error.response){
                            console.log(error.response)
                            this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
                            this.$store.commit('setSnackBarColor', "red darken-4")
                            this.$store.commit('activateSnackBar', true)
                        }else{
                            this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
                            this.$store.commit('setSnackBarColor', "red darken-4")
                            this.$store.commit('activateSnackBar', true)
                        }
                    })
                this.$store.commit('setIsLoading', false)
            },
        },

        watch: {
            '$route': function(to, from) {
                this.getCampaigns();
            }
        },

        mounted(){
            this.getCampaigns();
            const campaign_category = this.$route.params.category
            document.title = "PettyCash | "+campaign_category+" user's campaigns"
            sessionStorage.setItem('url', window.location.href);
            this.$store.commit('setCloseURL', "/savings")
            this.$store.commit('setSaveItem', "")
        },
    }
</script>

<style scoped>

.transfer-btn {
    min-width: 160px !important;
    border-radius: 24px !important;
    background: linear-gradient(135deg, #7b1fa2 0%, #4a0072 100%) !important;
    box-shadow: 0 4px 12px rgba(123, 31, 162, 0.3) !important;
    transition: all 0.3s ease;
    letter-spacing: 0.5px;
    text-transform: none;
    height: 36px !important;
}

.transfer-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(123, 31, 162, 0.4) !important;
}

.transfer-btn:active {
    transform: translateY(1px);
}

/* Amélioration du menu déroulant */
.menu-card {
    border-radius: 14px !important;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.95) !important;
    backdrop-filter: blur(10px);
    border: 1px solid #e0e0e0;
}

.menu-list {
    padding: 6px 0 !important;
}

.menu-item {
    padding: 10px 16px !important;
    transition: all 0.25s ease;
    cursor: pointer;
}

.menu-item:hover {
    background-color: #f5f5f5 !important;
    transform: translateX(3px);
}

.send-item:hover {
    background: linear-gradient(to right, #e8f5e9, #ffffff) !important;
}

.receive-item:hover {
    background: linear-gradient(to right, #e3f2fd, #ffffff) !important;
}

.menu-divider {
    background-color: #e0e0e0 !important;
    margin: 4px 0 !important;
}

/* Animation pour le menu */
.slide-y-transition-enter-active {
    animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
    0% {
        opacity: 0;
        transform: translateY(-10px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

blink {
    -webkit-animation: 4s linear infinite condemned_blink_effect;
    animation: 4s linear infinite condemned_blink_effect;
}

@-webkit-keyframes condemned_blink_effect {
    0% { visibility: hidden; }
    50% { visibility: hidden; }
    100% { visibility: visible; }
}

@keyframes condemned_blink_effect {
    0% { visibility: hidden; }
    50% { visibility: hidden; }
    100% { visibility: visible; }
}

.button-group {
    gap: 8px;
}
</style>
